module.exports = __webpack_public_path__ + "img/payl8r.a74ab56c.png";